<template>
  <div class="content">
    <div class="page-inner">
      <section class="scrollable">
        <div class="pos-rlt">
          <h2 class="text-black strong mb-0 mt-2">{{ $t('my_playlists') }}</h2>
        </div>
        <section class="mt-2">
          <div class="text-right mb-2">
            <router-link to="/user/playlists/create" class="btn btn-primary">
              {{ $t('create_playlist') }}
            </router-link>
          </div>
          <p class="mt-2" v-if="!loading && !userPlaylists.length">
            {{ $t('dont_have_playlists_yet') }}
          </p>
          <div class="alert alert-warning mt-2" v-if="!accessToken">
            <div>{{ $t('please_give_us_authorization') }}</div>
            <div class="mt-2">
              <button type="button" class="btn btn-primary" @click="loginSpotify()"><i class="fab fa-spotify mr-2"></i>{{ $t('request_access' ) }}</button>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-md-4" v-for="(item) in userPlaylists" v-bind:key="item._id">
              <div class="card">
                <div class="card-body p-0">
                  <div class="clearfix m-1">
                    <div class="float-left strong">
                      <div class="text-muted block">
                        {{ $t('cost') }}: <span class="text-primary strong">{{ parseInt(item.followers * followerCost) }} {{ $t('credits') }}</span>
                      </div>
                      <div class="text-muted block">
                        {{ $t('followers') }}: <span class="text-strong">{{ item.followers }}</span>
                      </div>
                    </div>
                    <router-link :to="'/user/playlists/' + item._id" class="btn btn-default btn-sm float-right mt-2">
                      {{ $t('view_applications') }}<span class="badge badge-primary ml-1" v-if="item.requests">{{ item.requests }}</span>
                    </router-link>
                    <button type="button" class="btn btn-sm btn-danger float-right mt-2 mr-2" @click="removePlaylist(item)">
                      <i class="fa fa-trash"></i>
                    </button>
                  </div>
                  <iframe :src="item.embedUrl" width="100%" height="380" frameborder="0" allowtransparency="true" allow="encrypted-media"></iframe>
                </div>
              </div>
            </div>
          </div>
        </section>
        <div class="m-b-lg m-t-lg wrapper-lg"></div>
      </section>
    </div>
  </div>
</template>
<script>
export default {
  data: function () {
    return {
      followerCost: 1.5,
      accessToken: '',
      defaultImage: 'https://indiefy.net/img/img-placeholder.jpg',
      loading: true,
      userPlaylists: []
    }
  },
  methods: {
    removePlaylist: function (playlist) {
      window.swal({
        title: this.$t('are_you_sure'),
        closeOnEsc: false,
        closeOnClickOutside: false,
        icon: 'warning',
        buttons: {
          cancel: {
            text: this.$t('cancel'),
            className: 'btn btn-dark',
            visible: true
          },
          confirm: {
            text: this.$t('remove_playlist'),
            className: 'btn btn-primary'
          }
        }
      }).then((confirm) => {
        if (confirm) {
          this.$http.delete(`${window.apiURL}api/user/playlists/${playlist._id}`, { withCredentials: true }).then(response => {
            this.getPlaylists()
            this.$notify({ message: this.$t('campaign_removed') }, 'success', 'fa-check')
          })
        }
      })
    },
    loginSpotify: function () {
      let baseUrl = ''

      if (location.href.match(/localhost/)) {
        baseUrl = 'http://localhost:8082/spotify-auth'
      } else {
        baseUrl = 'https://network.indiefy.net/spotify-auth'
      }

      let CLIENT_ID = '6e4a92b2f27b47de827b03198075ee37'
      let REDIRECT_URI = baseUrl

      function getLoginURL (scopes) {
        return 'https://accounts.spotify.com/authorize?client_id=' + CLIENT_ID +
          '&redirect_uri=' + encodeURIComponent(REDIRECT_URI) +
          '&scope=' + encodeURIComponent(scopes.join(' ')) +
          '&response_type=code'
      }

      let url = getLoginURL([
        'user-read-email',
        'user-follow-modify',
        'user-library-modify',
        'playlist-modify-public'
      ])

      window.addEventListener('message', function (event) {
        if (event.data && event.data.match && event.data.match(/\{/)) {
          let hash = JSON.parse(event.data)
          if (hash.type === 'access_token') {
            this.$spotify.token = hash.access_token
            this.accessToken = hash.access_token
            localStorage.setItem('spotifyToken', hash.access_token)
            localStorage.setItem('tokenDate', new Date().toString())
            this.getPlaylists()
          }
        }
      }, false)

      localStorage.setItem('redirectTo', '/user/playlists')
      location.href = url
      // window.open(url, 'Spotify', 'menubar=no,location=no,resizable=no,scrollbars=no,status=no, width=' + width + ', height=' + height + ', top=' + top + ', left=' + left)
    },
    getPlaylistData: function (playlist) {
      let playlistId = playlist.url || ''

      try {
        if (playlistId.match(/\//)) {
          playlistId = playlistId.split('/playlist/')[1]
        }

        if (playlistId && playlistId.match(/\//)) {
          playlistId = playlistId.split('/')[0]
        }

        if (playlistId.match(/\?/)) {
          playlistId = playlistId.split('?')[0]
        }
      } catch (e) {
        console.error('Error when getting playlist id', playlist)
      }

      $.ajax({
        url: `https://api.spotify.com/v1/playlists/${playlistId}`,
        headers: {
          'Authorization': 'Bearer ' + this.accessToken
        },
        method: 'GET',
        success: (data) => {
          if (data && data.images && data.images[0]) {
            playlist.image = data.images[0].url
          }

          if (data && data.followers) {
            playlist.followers = data.followers.total
          }
        },
        dataType: 'json',
        error: function (e) {
          console.error(e, playlist)
        }
      })
    },
    getPlaylists: function () {
      this.$http.get(`${window.apiURL}api/user/playlists`, { withCredentials: true }).then(response => {
        const items = response.data

        _.each(items, item => {
          item.followers = 0
          item.image = ''
          item.embedUrl = item.url.replace('.com/user', '.com/embed/user')
          item.requests = 0

          this.$http.get(`${window.apiURL}api/playlist-request/${item._id}`, { withCredentials: true }).then(response => {
            item.requests = _.filter(response.data, item => !item.status).length
          })
        })

        this.userPlaylists = items
        this.loading = false

        _.each(this.userPlaylists, item => this.getPlaylistData(item))
      })
    }
  },
  created () {
    if (this.$spotify.token) {
      this.accessToken = this.$spotify.token
      this.getPlaylists()
    }
  }
}
</script>
<style scoped>
  .users-table-container {
    max-height: 200px;
    overflow: auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/UserPlaylists.vue